import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom';
import Alert from '../../components/layout/Alert';
import dropdown from './../../img/plus_icon.svg'

const Header = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Fragment>
            <div className='serviceHeader'>
                <div className='d-flex justify-content-between p-3'>
                    <h2 className='fw-bold'>{props.heading}</h2>
                    <Alert />
                    <div>
                        <button onClick={() => setIsOpen(!isOpen)} className='btn  btn-lg  dropdownMain'>Add  <img src={dropdown} alt="dropdown"  className='ps-2' /> </button>

                        {isOpen && (
                            <div className='dropdownMenu position-absolute'>
                                <Link to="/catalogue/create-category" className='dropdownMenu_link'>Category</Link>
                                <Link to="/catalogue/create-service" className='dropdownMenu_link'>Service</Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default Header
